export const lookInsideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/unLoEZcs4yWmSgpJSzi3eU/Captura-de-pantalla-2026-09-28-a-la_s_-10.41.30_p._m..png',
    alt: 'Physio Ready exercise prescription sheet: Supported Standing Hip Extension — Control',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gRJZ1N1vDPBYXDQdhiPYoS/Captura-de-pantalla-2026-09-28-a-la_s_-10.41.08_p._m..png',
    alt: 'Physio Ready exercise prescription sheet: Straight Leg Raise — Quadriceps Control Progression',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wqRtqUqSRUNMmXZ37rnEsx/Captura-de-pantalla-2026-09-28-a-la_s_-10.41.39_p._m..png',
    alt: 'Physio Ready exercise prescription sheet: Open Book — Side-Lying Thoracic Rotation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ded8vQXMmF8546yqPyMxmP/Captura-de-pantalla-2026-09-28-a-la_s_-10.41.19_p._m..png',
    alt: 'Physio Ready exercise prescription sheet: Band Terminal Knee Extension — Controlled Knee Extension',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1swXjXio7Xy3DLacQeEu4J/Captura-de-pantalla-2026-09-28-a-la_s_-10.40.49_p._m..png',
    alt: 'Physio Ready exercise prescription sheet: Ankle Band Exercise Series',
  },
]
